import {observer} from 'mobx-react-lite'
import React, {SyntheticEvent, useEffect, useRef, useState} from 'react'
import PrismaZoom from 'react-prismazoom'
import tw from 'tailwind-styled-components'
import {Util} from 'yougile-util'
import {Backend} from '@common/backend'
import {noPropagate, useForceUpdate} from '@containers/hooks'
import {cn} from '@containers/html-utils'
import {isFirefox, isSafari} from '@extensions/platform'
import {RefZoom, useFileViewerStore} from '../file-viewer-store'

const TwWrapper = tw.div<{$itemsCenter: boolean}>`
  flex
  justify-center
  h-full
  overflow-hidden
  ${p => (p.$itemsCenter ? 'items-center' : '')}
`

const safari = isSafari()

export const ImageView = observer(() => {
  const [state, store] = useFileViewerStore()
  const refZoom = useRef<RefZoom>()
  const ref = useRef<HTMLDivElement>(null)
  const [hasWidthOverflow, setHasWidthOverflow] = useState(false)
  const [hasHeightOverflow, setHasHeightOverflow] = useState(false)
  const isMozillaOrDesktop = Util.isDesktop() || isFirefox()

  const upd = useForceUpdate()
  useEffect(() => {
    upd()
  }, [state.currentFileIndex])

  const close = () => {
    state.onClose()
  }

  const onZoomChange = (zoom: number) => {
    store.setZoom(zoom)
  }

  useEffect(() => {
    store.setRefZoom(refZoom)
  }, [refZoom])

  const height =
    (Boolean(hasWidthOverflow && hasHeightOverflow) && '100%') ||
    (Boolean(!hasWidthOverflow && hasHeightOverflow) && '100%') ||
    ''

  const itemsCenter =
    Boolean(hasWidthOverflow && hasHeightOverflow) ||
    Boolean(!hasWidthOverflow && hasHeightOverflow)

  const handleImageLoad = (e: SyntheticEvent<HTMLImageElement>) => {
    const target = e.target as HTMLImageElement
    setHasWidthOverflow(Number(ref.current?.clientWidth) < target.clientWidth)
    setHasHeightOverflow(
      Number(ref.current?.clientHeight) < target.clientHeight
    )
    store.setZoom(1)
  }

  return (
    <>
      <TwWrapper onClick={close} $itemsCenter={!itemsCenter} ref={ref}>
        <PrismaZoom
          ref={refZoom}
          onZoomChange={onZoomChange}
          className={cn(
            'flex items-center',
            height ? 'h-full' : '',
            safari && !height ? 'h-full' : ''
          )}
        >
          <img
            onClick={noPropagate}
            src={Backend.toDataUrl(state.image.src)}
            style={{
              height: height,
              width:
                (safari && height) || (isMozillaOrDesktop && height)
                  ? ''
                  : '100%'
            }}
            className="m-auto bg-center bg-no-repeat bg-contain"
            onLoad={handleImageLoad}
          />
        </PrismaZoom>
      </TwWrapper>
    </>
  )
})
